const DB_NAME = 'sofera'
const DB_VERSION = 1
const STORE = 'kv'

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') return reject(new Error('indexedDB indisponível'))
    const req = indexedDB.open(DB_NAME, DB_VERSION)
    req.onupgradeneeded = () => {
      const db = req.result
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE)
    }
    req.onsuccess = () => resolve(req.result)
    req.onerror = () => reject(req.error || new Error('Falha ao abrir IndexedDB'))
  })
}

function withStore(mode, fn) {
  return openDb().then((db) => new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, mode)
    const store = tx.objectStore(STORE)
    let out
    try {
      out = fn(store)
    } catch (e) {
      try { tx.abort() } catch (e2) { void e2 }
      reject(e)
      return
    }
    tx.oncomplete = () => resolve(out)
    tx.onerror = () => reject(tx.error || new Error('Falha na transação IndexedDB'))
    tx.onabort = () => reject(tx.error || new Error('Transação IndexedDB abortada'))
  }))
}

export async function idbGet(key) {
  const db = await openDb()
  return await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readonly')
    const store = tx.objectStore(STORE)
    const req = store.get(key)
    req.onsuccess = () => resolve(req.result ?? null)
    req.onerror = () => reject(req.error || new Error('Falha ao ler IndexedDB'))
  })
}

export async function idbSet(key, value) {
  return await withStore('readwrite', (store) => store.put(value, key))
}

export async function idbDel(key) {
  return await withStore('readwrite', (store) => store.delete(key))
}
